import React from "react";
import { Route, Redirect } from "react-router-dom";
import applicationRoles from "constants/applicationRoles";

let redirectPath = "/AccessDenied";
let shouldLoadComponent = true;

/*
 * Routes require the following
 * authentication
 * prop allRoles or one ore more of the following
 * systemAdmin
 * sponsor
 */

// Specify the target component using the prop component

const PrivateRoute = ({ Component, ...rest }) => {
  const { component, authentication, ...routeProps } = rest;
  if (typeof component !== "undefined") {
    throw new Error("Do not use the `component` prop of <PrivateRoute/>. The correct prop is `Component` (note the capital C).");
  }

  if (!authentication || !authentication.loaded) {
    localStorage.setItem("authRedirect", JSON.stringify(routeProps));

    return null;
  }
  const { authed, user } = authentication;
  redirectPath = !authed ? "/login" : "/AccessDenied";
  
  if (!authed) {
    shouldLoadComponent = false;
  } else if (authed && user.roles && (routeProps.systemAdmin || routeProps.user || routeProps.companyAdmin)) {
    if (routeProps.allRoles) {
      shouldLoadComponent = true;
    } else {
      shouldLoadComponent = (routeProps.systemAdmin && user.roles.includes(applicationRoles.SYSTEMADMIN)) ||
                            (routeProps.companyAdmin && user.roles.includes(applicationRoles.COMPANYADMIN)) ||
                            (routeProps.user && user.roles.includes(applicationRoles.USER)) ||
                            (routeProps.guest && user.roles.includes(applicationRoles.GUEST));
    }
  } else {
    shouldLoadComponent = (authed === true);
  }

  return (
    <Route
      {...routeProps}
      render={props => (shouldLoadComponent ?
        (<Component {...routeProps} {...props} />) :
        (<Redirect to={{ pathname: redirectPath, state: { from: props.location } }} />))}
    />
  );
};

export default (PrivateRoute);
